import React from 'react';

import { Flex, useTheme } from '@chakra-ui/react';
import { HeaderMarginContainer } from 'Deer/components/HeaderComponents/HeaderMarginContainer';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isMobileView } from 'constants/isMobileView';

import { TextHeader2 } from 'uiToolkitV1/Typography';

import { TimelineDropdown } from './TimelineDropdown';

const Heading = ({ teamName, containerProps = {}, textProps = {}, showTimeline }) => {
  const theme = useTheme();

  return (
    <HeaderMarginContainer>
      <Flex
        alignItems="center"
        as="h1"
        bgColor={theme.colors.surface.F5F7F9}
        px={(isMobileView() ? 3 : 0) + (!checkNewNavEnabled() ? 4 : 0)}
        py={!checkNewNavEnabled() ? 2 : 0}
        {...containerProps}
      >
        <TextHeader2 bold py={2} ml={0} mr="8px" {...textProps}>
          {teamName} {showTimeline ? 'for' : ''}
        </TextHeader2>
        {showTimeline && <TimelineDropdown isPageHeaderTimeline />}
      </Flex>
    </HeaderMarginContainer>
  );
};
export default Heading;
